import React from 'react';
import { Link } from 'react-router-dom';


const SideCard = ({ item }) => {
  return (
    <Link
      to={item.linkUrl}
      target={item.externalLink ? '_blank' : ''}
      className="group flex h-full flex-row overflow-hidden  bg-[#ffffff] transition  hover:no-underline"
    >
      <div className="aspect-[16/9] w-[38%] sm:w-[38%] md:w-[40%]  self-start overflow-hidden sm:aspect-[16/9] ">
        <img
          src={item.imageUrl}
          alt={item.header}
          className="h-full w-full object-contain transition duration-300 hover:no-underline"
        />
      </div>
      <div className="flex-1 px-4 xs:px-5 ">
        <h3
          className=" uppercase leading-none text-black text-[1.5rem]"
          style={{ fontFamily: "Knockout Wide, sans-serif" }}
        >
          {item.header}
        </h3>
        <p
          className="mt-2 text-sm xs:text-sm sm:text-sm md:text-sm lg:text-sm leading-snug text-black/90 "
          style={{ fontFamily: "Roboto, sans-serif" }}
        >
          {item.copy}
        </p>
      </div>
    </Link>
  );
}

export default SideCard;